import { someLoanableAllowsDeclaredExpenses } from "@/billingSettings";

export default {
  data() {
    return {
      declaredExpenseLoanables: [],
      declaredExpenseLoanablesLoaded: false,
      declaredExpenseRequest: null,
    };
  },
  computed: {
    expenseCommunityId() {
      const user = this.$store.state.user;
      if (!user) {
        return null;
      }
      if (this.$store.state.communities.current) {
        return this.$store.state.communities.current;
      }
      return user.main_community ? user.main_community.id : null;
    },
    canDeclareExpense() {
      return (
        this.declaredExpenseLoanablesLoaded &&
        someLoanableAllowsDeclaredExpenses(this.declaredExpenseLoanables)
      );
    },
  },
  watch: {
    expenseCommunityId: {
      immediate: true,
      handler(communityId) {
        this.loadDeclaredExpenseAvailability(communityId);
      },
    },
  },
  methods: {
    async loadDeclaredExpenseAvailability(communityId) {
      this.declaredExpenseRequest = communityId;
      if (!communityId) {
        this.declaredExpenseLoanables = [];
        this.declaredExpenseLoanablesLoaded = !!this.$store.state.user;
        return;
      }

      this.declaredExpenseLoanablesLoaded = false;
      try {
        const { data } = await this.axios.get("/loanables", {
          params: {
            per_page: "*",
            community_id: communityId,
            fields: "id,allows_declared_expenses,owner.allows_declared_expenses",
          },
        });
        if (this.declaredExpenseRequest !== communityId) {
          return;
        }
        this.declaredExpenseLoanables = Array.isArray(data) ? data : data.data || [];
      } catch (error) {
        if (this.declaredExpenseRequest !== communityId) {
          return;
        }
        this.declaredExpenseLoanables = [];
      }
      this.declaredExpenseLoanablesLoaded = true;
    },
  },
};
